export const apiErrorMessage = (e, fallback = 'Something went wrong') => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === 'string') return d;
  if (typeof d === 'object') return d.message || d.error || fallback;
  return fallback;
};
